<div class="modal-header">
  <h2>Google Map</h2>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss({ marker: null, address: null })">
    <svg version="1.1" x="0px" y="0px" width="14" height="14" viewBox="0 0 14 14">
      <path class="icon-stroke" fill="none" stroke-width="2" stroke-linecap="square" d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5" />
    </svg>
  </button>
</div>
<div class="modal-body">
  <div class="form-group">
    <label>Enter address</label>
    <input type="text" class="form-control" (keydown.enter)="$event.preventDefault()" placeholder="Search Nearest Location" autocorrect="off" autocapitalize="off" spellcheck="off" type="text" #search>
  </div>

  <agm-map [latitude]="marker?.latitude" [longitude]="marker?.longitude" [zoom]="zoom">
    <agm-marker [latitude]="marker?.latitude" [longitude]="marker?.longitude" [markerDraggable]="true" (dragEnd)="markerDragEnd($event)"></agm-marker>
  </agm-map>

  <h5>Address: {{address}}</h5>
  <div>Latitude: {{marker?.latitude}}</div>
  <div>Longitude: {{marker?.longitude}}</div>

</div>
<div class="modal-footer">
  <button type="button" class="tu-btn blue" i18n="@@google_map.get_location" (click)="closeModal(marker,address)">Get Location</button>
  <button type="button" class="tu-btn pink" i18n="@@cropper.cancel" (click)="activeModal.dismiss({ marker: null, address: null })">Cancel</button>
</div>
